import { render } from "./PageHeaderView.vue?vue&type=template&id=8e02de2c&scoped=true&lang=pug"
import script from "./PageHeaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./PageHeaderView.vue?vue&type=script&setup=true&lang=js"

import "./PageHeaderView.vue?vue&type=style&index=0&id=8e02de2c&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e02de2c"]])

export default __exports__